<template>
  <div class="w-full">
    <template v-if="!initialLoading && courses.length > 0">
      <ul
        role="list"
        class="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-2 2xl:grid-cols-3 3xl:grid-cols-3 4xl:grid-cols-4 5xl:grid-cols-5"
      >
        <V4CourseCard
          v-for="course in filteredCourses"
          :key="course.id"
          :course="course"
          :hasIsEnrollProperty="hasIsEnrollProperty(course)"
        />
      </ul>
      <div v-if="!loadingCourses && !initialLoading" class="flex justify-center mt-5">
        <button
          v-if="hasMore"
          @click="loadMore"
          class=" inline-flex justify-center items-center gap-1.5 px-3 py-2 text-sm font-medium rounded-md text-white bg-app-primary hover:bg-app-secondary transition-colors truncate min-w-0 cursor-pointer"
          type="primary"
        >
          Load More
        </button>
      </div>
    </template>

    <div v-if="loadingCourses || initialLoading" class="mt-3">
      <V4LoadingCourses :data="loadingCoursesData" />
    </div>

    <EmptyData
      v-if="!loadingCourses && !initialLoading && courses.length === 0"
      description="No courses found."
    />
  </div>
</template>

<script setup>
import { useHomeCoursesStore } from "@/stores/home/useHomeCourses.store";
import { storeToRefs } from "pinia";
import EmptyData from "@/components/utilities/EmptyData.vue";
import { computed } from "vue";
import V4CourseCard from "./partials/V4CourseCard.vue";
import V4LoadingCourses from "./V4LoadingCourses.vue";

const homeCoursesStore = useHomeCoursesStore();

const { filteredCourses, loadingCourses, initialLoading, courses, hasMore } =
  storeToRefs(homeCoursesStore);
const loadingCoursesData = computed(() => []);

const hasIsEnrollProperty = (course) => {
  if (course && course.id) {
    const object = structuredClone(course);
    return Object.prototype.hasOwnProperty.call(object, "is_enrolled");
  }

  return false;
};

const loadMore = async () => {
  // Store current course count before loading more
  const previousCourseCount = homeCoursesStore.baseCourses.length;

  await homeCoursesStore.loadMoreCourses();

  // Get only the newly loaded course IDs
  const allCourses = homeCoursesStore.baseCourses;
  const newCourses = allCourses.slice(previousCourseCount);
  const newCourseIds = newCourses.map((course) => course.id);

  // Fetch progress only for new courses
  if (newCourseIds.length > 0) {
    await homeCoursesStore.handleFetchCourseProgress(newCourseIds, true); // true = append mode
  }

  window.scrollTo({
    top: document.documentElement.scrollHeight,
    behavior: "smooth",
  });
};
</script>

<style scoped></style>
